import React, { FC, useState, useEffect, useContext, useMemo } from "react";
import ApplItem from "./ApplItem";

import "./styles.sass";
import Pagination from "../../../components/pagination/Pagination";
import Emptiness from "../../../components/UI/emptiness/Emptiness";
import Timofey from "../../../assets/images/Timofey_avatar.png";
import { Context } from "../../..";

interface IUserApplications {
  value: string;
  data?: any;
}

const UserApplications: FC<IUserApplications> = ({ data }) => {
  const { store, roles } = useContext(Context);

  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 5; // Set the number of items to display per page
  const [adminPermissionData, setAdminPermissionData] = useState<any>();

  // Calculate the index range for the current page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Get the data sorted by date
  const sortedData = useMemo(() => {
    if (!data?.applications) return [];
    // Custom sorting function to compare createdAt values
    function customDateSort(a: any, b: any) {
      const dateA = new Date(
        a.createdAt.replace(
          /(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/,
          "$3-$2-$1T$4:$5:00.000Z"
        )
      );
      const dateB = new Date(
        b.createdAt.replace(
          /(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/,
          "$3-$2-$1T$4:$5:00.000Z"
        )
      );

      return dateB.getTime() - dateA.getTime();
    }

    // Sort the array based on the createdAt values
    return data?.applications.sort(customDateSort);
  }, [data]);

  // Get the data for the current page

  const [currentPageData, setCurrentPageData] = useState(
    sortedData?.slice(startIndex, endIndex) || []
  );
  const userId = data?._id;

  useEffect(() => {
    setCurrentPageData(sortedData?.slice(startIndex, endIndex));
  }, [sortedData, startIndex, endIndex]);

  const loadNewData = async () => {
    const id = store.user._id;
    const userData = await roles.fetchSingleUserById(id);
    setAdminPermissionData(userData?.data?.role[1]?.children[0]);
  };

  useEffect(() => {
    loadNewData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="section">
      <div className="section-title">
        <span>User applications</span>
        <Pagination
          totalItems={sortedData?.length}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
        />
      </div>

      <div className="section-main">
        {currentPageData && currentPageData.length > 0 ? (
          currentPageData.map((item: any, index: number) => (
            <ApplItem
              data={item}
              key={item.id}
              user={data}
              index={index}
              userId={userId}
              actionData={adminPermissionData}
            />
          ))
        ) : (
          <Emptiness icon={Timofey} content="There are no user application" />
        )}
      </div>
    </section>
  );
};

export default UserApplications;
